module.exports = __webpack_public_path__ + "static/media/branding-img16.f40243e7.jpg";